// src/components/AddCompanyForm/AddressLegalCard.jsx
import React from "react";
import {
  Card, CardHeader, CardContent, Grid, TextField, InputAdornment,
} from "@mui/material";
import PublicRoundedIcon from "@mui/icons-material/PublicRounded";
import RoomRoundedIcon from "@mui/icons-material/RoomRounded";
import BadgeRoundedIcon from "@mui/icons-material/BadgeRounded";
import { onlyDigits } from "./utils";

export default function AddressLegalCard({ form, setForm }) {
  const set = (patch) => setForm((p) => ({ ...p, ...patch }));
  return (
    <Card variant="outlined">
      <CardHeader title="Endereço, Site & Legais" subheader="URL pública, endereço e CNPJ" />
      <CardContent sx={{ pt: 0 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Site"
              value={form.site}
              onChange={(e) => set({ site: e.target.value })}
              fullWidth
              placeholder="https://suaempresa.com.br"
              InputProps={{ startAdornment: <InputAdornment position="start"><PublicRoundedIcon fontSize="small" /></InputAdornment> }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Endereço"
              value={form.endereco}
              onChange={(e) => set({ endereco: e.target.value })}
              fullWidth
              multiline
              minRows={2}
              placeholder="Rua, número, bairro, cidade/UF"
              InputProps={{ startAdornment: <InputAdornment position="start"><RoomRoundedIcon fontSize="small" /></InputAdornment> }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="CNPJ"
              value={form.cnpj}
              onChange={(e) => set({ cnpj: onlyDigits(e.target.value).slice(0, 14) })}
              fullWidth
              placeholder="00.000.000/0000-00"
              InputProps={{ startAdornment: <InputAdornment position="start"><BadgeRoundedIcon fontSize="small" /></InputAdornment> }}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
